import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BackofficeCartridgeService } from '@markant-platform/backoffice/data-access';
import { Breadcrumb } from '@markant-platform/shared/breadcrumb/feature';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VariantsOverviewBreadcrumbResolver {
  constructor(private readonly backofficeCartridgeService: BackofficeCartridgeService) {}

  async resolve(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): Promise<Observable<Breadcrumb[]>> {
    const cartridgeId: string = route.paramMap.get('cartridgeId') || '';

    return this.backofficeCartridgeService.getCartridgeVariantById(cartridgeId).pipe(
      map(cartridgeDto => {
        return [{ url: cartridgeId, label: cartridgeDto.variantName }];
      })
    );
  }
}
